import { WorkflowQuestionConfig } from '../workflowQuestionConfig';
import { WorkflowResponseState } from '../workflowResponseState';

export interface LocationQuestionConfig extends WorkflowQuestionConfig {
  includeMemo?: boolean;
}

export interface LocationResponseState extends WorkflowResponseState {
  value?: string;
  coordinates?: [number, number];
  memo?: string;
}
